import { HeartIcon, SparklesIcon, UsersIcon } from "../common/icons/icons";

type howItWorksType = {
  icon: any;
  title: string;
  description: string;
  step: string;
};

export const howItWorks: howItWorksType[] = [
  {
    icon: UsersIcon,
    title: "Sign Up",
    description:
      "Complete a thoughtful questionnaire to help us understand you.",
    step: "01",
  },
  {
    icon: HeartIcon,
    title: "Get Matched",
    description: "Our team carefully finds your perfect match.",
    step: "02",
  },
  {
    icon: SparklesIcon,
    title: "Your Date",
    description: "Experience a genuine connection with real conversation.",
    step: "03",
  },
];
